export const primary = "#00D2B7";
export const warning = "#ba3434";
